<script>
import Address from "../Address/Index";

export default {
  components: {
    Address
  }
};
</script>

<template>
  <div class="beginning">
    <Address />
  </div>
</template>

<style scoped>
.beginning {
  max-width: 500px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Components/Scheduler/Steps/Beggining/Index.vue